import { useEffect, useRef, useState } from "react";
import { Banner, BannerOverlay, BannerPositionLeft, BannerPositionRight, Close } from "./style";

const BannerLogoFlotante = () => {
  const [isClient, setIsClient] = useState(false);
  const divNav = useRef();

  const openNav = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    const targetingValue = event.currentTarget.getAttribute("data-targeting");
    if (divNav.current) {
      try {
        googletag?.cmd?.push(() => {
          googletag.pubads().setTargeting('intro_aniversario', targetingValue);
          googletag.pubads().refresh([targetSlotFlotante1b]);
        });
        if (targetSlotFlotante1b) {
          document.querySelector('.intro-bg').classList.add('show')
          const closeBtn = document.querySelector('#close-introf1b-btn')

          closeBtn.addEventListener('click', () => {
            console.log('%ccloseBtn',"background:red;color:white:font-size:16px;padding:2px;color:white;font-weight:bold", closeBtn)
            document.querySelector('.intro-bg').classList.remove('show')
            document.querySelector("#div-gpt-ad-flotante1b").innerHTML = "";
          })
          setTimeout(() => {
            if(document.querySelector('.intro-bg')){
              document.querySelector('.intro-bg').classList.remove('show')
              document.querySelector("#div-gpt-ad-flotante1b").innerHTML = "";
            }
          }, 10000);
        }
      } catch (error) {
        console.log({error, targetSlotFlotante1b});
      }      
    }
  };

  let slotsIdsLeft = ["logo1", "logo2", "logo3", "logo4", "logo5", "logo6", "logo7", "logo8", "logo9", "logo10"];
  let slotsIdsRight = ["logo11", "logo12", "logo13", "logo14", "logo15", "logo16", "logo17", "logo18", "logo19", "logo20"];
  
  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient ? (
    <>
      <BannerPositionLeft>
        {slotsIdsLeft.map((id) => {
          return (
            <Banner key={id} id={id} data-targeting={id} onClick={openNav}>
              <div id={`div-gpt-ad-${id}`} />
            </Banner>
          );
        })}

      </BannerPositionLeft>
      <BannerPositionRight>
        {slotsIdsRight.map((id) => {
          return (
            <Banner key={id} id={id} data-targeting={id} onClick={openNav}>
              <div id={`div-gpt-ad-${id}`} />
            </Banner>
          );
        })}

      </BannerPositionRight>
      <BannerOverlay className="intro-bg" ref={divNav}>
        <Close type="button" id="close-introf1b-btn">X</Close>
        <div id="div-gpt-ad-flotante1b" />
      </BannerOverlay>
    </>
  )
    : (
      <></>
    );
};

export default BannerLogoFlotante;
